import {
  useId,
  type InputHTMLAttributes,
  type ReactNode,
  type Ref,
} from 'react';
import clsx from 'clsx';
import './Toggle.css';

export interface ToggleProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: ReactNode;
  /** Place the track on the right (default) or left of the label. */
  trackPosition?: 'right' | 'left';
  ref?: Ref<HTMLInputElement>;
}

export function Toggle({
  label,
  trackPosition = 'right',
  disabled,
  id,
  className,
  ref,
  ...rest
}: ToggleProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const track = (
    <span className="fluent-toggle__track" aria-hidden="true">
      <span className="fluent-toggle__thumb" />
    </span>
  );

  return (
    <label
      className={clsx('fluent-toggle', className)}
      data-disabled={disabled || undefined}
      htmlFor={inputId}
    >
      <input
        ref={ref}
        id={inputId}
        type="checkbox"
        role="switch"
        className="fluent-toggle__native"
        disabled={disabled}
        {...rest}
      />
      {trackPosition === 'left' && track}
      {label != null && <span className="fluent-toggle__label">{label}</span>}
      {trackPosition === 'right' && track}
    </label>
  );
}
